export default __webpack_public_path__ + "images/33edaafe98452311841561dad113068d.png";